import {
  ModalBuilder,
  Table,
  notifySuccess,
  ActionMenu,
} from "@redriver/cinnamon";
import React from "react";
import { useTranslation } from "react-i18next";
import { TranslatedModal } from "features/../../../shared/components/modals";
import { useDispatch } from "react-redux";
import { sendToIpsSignatory } from "./actions";
import { DropdownItem } from "semantic-ui-react";

const SendToIpsSignatory = ({ sheet, onSubmitted }) => {
  const { t } = useTranslation("agreements");
  const dispatch = useDispatch();
  const { sheetId, sheetName } = sheet;

  return (
    <ModalBuilder
      submitAction={sendToIpsSignatory}
      submitParams={{ sheetId }}
      onSubmitted={() => {
        dispatch(notifySuccess("Sheet successfully submitted"));
        onSubmitted();
      }}
      renderTrigger={(onTrigger) => (
        <DropdownItem onClick={onTrigger}>
          {t("SheetActions.SendToIpsSignatory.TriggerText")}
        </DropdownItem>
      )}
      renderModal={(modalProps) => (
        <TranslatedModal.Confirmation
          {...modalProps}
          header={t("SheetActions.SendToIpsSignatory.ModalHeader")}
        >
          {t("SheetActions.SendToIpsSignatory.ModalContent", { sheetName })}
        </TranslatedModal.Confirmation>
      )}
    />
  );
};

export default SendToIpsSignatory;
